import CONSTANTS from "../CONSTANTS";

export const actionGetAnalysisList = (options) => ({
  type: CONSTANTS.ANALYSIS_GET_LIST,
  options
});

export const actionSetAnalysisList = (entries) => ({
  type: CONSTANTS.ANALYSIS_SET_LIST,
  entries
});

export const actionSetLoadingAnalysisList = (val) => ({
  type: CONSTANTS.ANALYSIS_SET_LOADING_LIST,
  val
});

export const actionSetAnalysisPageIndex = (val) => ({
  type: CONSTANTS.ANALYSIS_SET_PAGE_INDEX,
  val
});

export const actionRequestStudyTypes = () => ({
  type: CONSTANTS.ANALYSIS_GET_STUDY_TYPES
});

export const actionSetStudyTypes = (types) => ({
  type: CONSTANTS.ANALYSIS_SET_STUDY_TYPES,
  types
});

export const actionSubmitAnalysis = (data) => ({
  type: CONSTANTS.ANALYSIS_SUBMIT_FORM,
  data
});

export const actionInviteNewPatient = (data) => ({
  type: CONSTANTS.ANALYSIS_INVITE_PATIENT,
  data
});

export const actionSetNewPatientData = (data) => ({
  type: CONSTANTS.ANALYSIS_SET_PATIENT_DATA,
  data
});

export const actionSetLoadingPatientData = (value) => ({
  type: CONSTANTS.ANALYSIS_LOADING_PATIENT,
  value
});